import axios from 'axios'

const service = axios.create({
    baseURL: '//www.lgs.cn/',
    timeout: 10000
})

service.interceptors.request.use(
	config => {
		
		return config;
	},
	error => {

	}
);

service.interceptors.response.use(
	response => {
		if (response.status === 200) {
			return response.data;
		} else {
			Promise.reject();
		}
	},
	error => {
		
	}
);

service.all = axios.all
service.spread = axios.spread
export default service;


// WEBPACK FOOTER //
// ./src/api/index.js